var Emitter = require('tiny-emitter');
var eventBus = new Emitter();

export default eventBus
